<template>
  <div class="editorial">
    <div class="editorial_nav">

      <div class="editorial_txt">
        <div class="iconfont iconhomeicon evolution_tu" style="margin-right: 5px;"></div>
        <div class="editorial_txt2">
          首页 <span class="span1">></span> <span class="span2">项目合作</span>
        </div>
      </div>
      
      <div class="editorial_left">
        <div class="express_rtitle">
          <div class="waike">项目合作</div>
          <div class="waixian"></div>
        </div>


        <div class="messageMain">

            <div class="messageAll" v-for="(item,index) in list"  @click="jump(2,item.contentId)" >

                <span :class="item.zt?'add2':''" class="numSpan">{{index>=9?(index+1):"0"+(index+1)}}</span>
                 <li :class="item.zt?'add1':''"  @mouseover="addtop(1,item.contentId)"
    
            @mouseout="addtop(2,item.contentId)" >{{item.title}}</li>

                <span  :class="item.zt?'add3':''"   @mouseover="addtop(1,item.contentId)"
    
            @mouseout="addtop(2,item.contentId)"  class="rightSpan">查看详情</span> 
            </div>



        </div>


      
      </div>
      <div class="editorial_right">
        <advertisement :num="num" :list2="list2"></advertisement>
      </div>
    </div>
  </div>
</template>

<script>
//配置右侧广告栏
import advertisement from "../public/evolution/advertisement.vue"

export default {
  components:{
    advertisement
  },
  data () {
    return {
      currentPage3: 1,//当前页数
      total: 0,//总条数
      num:{
        wai: false,
        zixun: true,
        xia: true,
        look: false,
		video2: true,
      },//控制广告栏的显示隐藏
      list2: [
        {
          id: 1,
          txt: '多西他赛对进展期胃癌术后化疗疗效影响向...'
        },
        {
          id: 2,
          txt: '中国腹腔镜减重代谢外科20年研究文献分析...'
        }
      ],//外科天地
      list:[
        
      ],
    }
  },

  methods:{
      index(){
          this.GetHomePageBlockInfo(2311)
        // this.total = this.list.length;
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.currentPage3 = val;
        console.log(`当前页: ${val}`);
      },
     jump(num,contentId){ //跳转
        this.$router.push({path:'/expert_details',query:{num: num,contentId: contentId}});
      },
      GetHomePageBlockInfo(ChannelId){
      var that = this;
      that.$httphelper.GetHomePageBlockInfo({
        "journalId": 201607080003,
        "pChannelId": 0,
        "channelId": ChannelId,
        "jChannelID": 0,
        "dataSourceType": 1,
        "dataShowType": 1,
        "curr": that.curr,
        "limit": that.limit,
      }).then(res => {
        if(res.code==200){
          that.list = res.data || '';
          that.total = res.totalcount;
          that.hide = true;
          that.$loading.hideLoading();
        }else{
          that.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      });
    },
      //鼠标悬停
      addtop(num,id){
        if(num==1){
          for(var i=0;i<this.list.length;i++){
            if(id==this.list[i].contentId){
              this.list[i].zt = true;
              this.list.push('1');
              this.list.pop('1');
            }
          }
        }else{
          for(var i=0;i<this.list.length;i++){
            this.list[i].zt = false;
            this.list.push('1');
            this.list.pop('1');
          }
        }
      },
  },
  created(){
    this.index();
  }
}
</script>

<style lang="scss" scoped>
*{
    margin: 0;
    padding: 0;
}
.editorial{
  width: 100%;
  min-width: 1366px;
  background-color: #FFFFFF;
  .editorial_nav{
    width: 85%;
    margin: 0 auto;
    overflow: hidden;
    .editorial_txt{
      width: 100%;
      margin-top: 24px;
      margin-bottom: 26px;
      overflow: hidden;
      .evolution_tu{
        width: 19px;
        height: 17px;
        float: left;
      }
      .editorial_txt2{
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #010101;
        .span1 {
          margin: 0 5px;
        }
        .span2 {
          color: var(--xt);
        }
      }
    }
    .editorial_left{
      width: 72%;
      margin-right: 3%;
      float: left;

      .messageMain{
          width: 100%;
          
          .messageAll{
            display: flex;
            align-items: center;
            width: 90%;
            // margin-top: 50px;
            cursor:pointer;
            margin-left: 50px;
            // height: 50px;
            margin-top: 50px;
            border-bottom: 1px solid #ccc;
            
            .numSpan{
              float: left;
              width: 47px;
              height: 43px;
              font-size: 36px;
              font-family: Helvetica;
              color: #7D8CA3;
              line-height: 43px;
            }
            li{
              margin-right:100px;
              flex:1;
              list-style-type: none;
              margin-left: 10px;
              margin-top: 20px;
              display: inline-block;
              margin-top: 10px;
              width: 454px;
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #222B3D;
              line-height: 30px;
              //  padding-bottom: 3px;
              // border-bottom: 1px solid #7D8CA3;
            }
            .rightSpan{
              float: right;
              // text-decoration: underline;
              padding-bottom: 3px;
              border-bottom: 1px solid #7D8CA3;
            }
          }
      }

      .express_rtitle {
        width: 100%;
        overflow: hidden;
        border-bottom: 3px solid #DBDBDB;
        padding-bottom: 11px;
        position: relative;
         .waike {
          width: 50%;
          float: left;
          font-size: 26px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #2A2D3E;
          line-height: 23px;
          margin-bottom: 20px;
        }
        .waixian {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100px;
          height: 3px;
          background: var(--biao);
        }
      }
      .express_nav2r {
        width: 100%;
        overflow: hidden;
        margin-top: 29px;
        .topContent{
           border: 1px solid #ccc;
           margin: 0 auto;
           width: 50%;
           height: 300px;
        }

        .express_list2 {
          width: 100%;
          overflow: hidden;
          cursor: pointer;
          margin-bottom: 12.3px;
          border-bottom: 1px solid #EBEBEB;
          line-height: 62px;
          .express_dian {
            width: 10px;
            height: 10px;
            background: #DBDBDB;
            border-radius: 50%;
            margin-right: 15px;
            float: left;
            margin-top: 27px;
          }

          .express_wen {
            width: 91%;
            float: left;

            .wen1 {
              width: 100%;
              font-size: 16px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #000000;


              .span3 {
                width: 80%;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                float: left;
              }
            }

            .wen2 {
              width: 100%;
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #636363;
              margin-bottom: 10px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }

          .zhai {
            width: 90%;
            padding-left: 31px;
            overflow: hidden;
            float: left;

            .wen3 {
              width: 50%;
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #636363;
              float: left;
            }

            .zhai_left,
            .zhai_right {
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #000000;
              float: right;
            }

            .zhai_right {
              margin-left: 30px;
            }

            .zhai_left:hover {
              text-decoration: underline;
              color: var(--biao);
            }

            .zhai_right:hover {
              text-decoration: underline;
              color: var(--biao);
            }
          }
        }
      }
      .el-pagination{
        text-align: center;
        margin-top: 30px;
      }
    }
    .editorial_right{
      width: 25%;
      float: left;
    }
  }
}
.add1 {
  color: var(--xt) !important;
  text-decoration: underline;
}

.add2 {
   color: var(--xt) !important;
}
.add3 {
  color: var(--xt) !important;
   padding-bottom: 3px;
    border-bottom: 1px solid var(--xt) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/evolution2.vue